import './dialog.less';
import { Dialog, Toast } from 'vant';
import { isNeedSafeBottomArea } from '@shared/utils';

type TConfirmProps = {
  title?: string;
  message: string;
  className?: string;
  callback?: () => void;
  cancelCB?: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

// 确认弹窗
const Confirm = ({
  title = '提示',
  message = '',
  callback,
  cancelCB,
  confirmButtonText = '确定',
  cancelButtonText = '取消',
}: TConfirmProps) => {
  Dialog.confirm({
    title,
    message,
    confirmButtonText,
    cancelButtonText,
    overlayClass: `m-dialog-overlay ${isNeedSafeBottomArea && 'safe-bottom-area'}`,
    className: `m-dialog ${isNeedSafeBottomArea && 'safe-bottom-area'}`,
  })
    .then(() => {
      callback?.();
    })
    .catch(() => {
      cancelCB?.();
    });
};

// 消息弹窗
const Alert = ({
  title = '温馨提示',
  message = '',
  callback,
  confirmButtonText = '知道了',
  className = '',
}: TConfirmProps) => {
  Dialog.alert({
    title,
    message,
    allowHtml: true,
    confirmButtonText,
    overlayClass: `m-dialog-overlay ${isNeedSafeBottomArea && 'safe-bottom-area'}`,
    className: `m-dialog ${className || ''} ${isNeedSafeBottomArea && 'safe-bottom-area'}`,
  }).then(() => {
    callback && callback();
  });
};

// 加载动画
const Loading = {
  show: (loadingMsg = '请求中...') => {
    Toast.loading({
      message: loadingMsg,
      forbidClick: true,
      duration: 0,
    });
  },
  hide: () => Toast.clear(),
};

export { Confirm, Alert, Loading };
